import { type Patient } from '@/types/patient'
import { createContext } from 'react'

type Props = {
  addPatients: (patient: Array<Patient>) => void
  searchValue: string
  setSearchValue: (value: string) => void
  filterDob: string
  setFilterDob: (value: string) => void
  removePatients: (patient: Array<Patient>) => void
  reset: () => void
  selectedPatients: Array<Patient>
}

export const MergeAccountsContext = createContext<Props | undefined>(undefined)
